import { useState } from 'react';
import { alertsMuted, setAlertsMuted, unlockAudio, fireAlert } from '../net/alert';

/** v5.5 §3: mute/unmute the foreground beep + haptics. Default ON (sound). The
 *  tap doubles as the iOS AudioContext unlock and previews the tone when turning
 *  sound back on. Persisted locally next to the Sim/Wake toggles. */
export function SoundToggle() {
  const [muted, setMuted] = useState(alertsMuted());
  const toggle = () => {
    const next = !muted;
    setAlertsMuted(next);
    setMuted(next);
    if (!next) {
      unlockAudio();
      fireAlert('ping'); // confirm sound is back on
    }
  };
  return (
    <button
      className="sim-toggle sound-toggle"
      data-active={!muted}
      data-testid="sound-toggle"
      onClick={toggle}
      title="Beep + vibrate when you must act (battery / quiet)"
    >
      <span className={`dot ${muted ? '' : 'dot--on'}`} />
      {muted ? 'Sound: off' : 'Sound: on'}
    </button>
  );
}
